<template>
  <div>
    <a-card style="margin: 20px" title="税筹商户配置">
      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>商户编号</span>
          <a-input v-model.trim="paramsData.merchantNo" allow-clear placeholder="请输入商户编号"/>
        </div>
        <div class="item">
          <span>商户名称</span>
          <a-input v-model.trim="paramsData.merchantName" allow-clear placeholder="请输入商户名称"/>
        </div>
        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 表格部分 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button v-if="$authority('merchantConfigAdd')" type="primary" @click="addBtn">新增商户</a-button>
          <a-button type="primary" @click="handleQuery">刷新</a-button>
          <a-button v-if="$authority('handleBatchMigrate')" :loading="migrateLoading" type="default" @click="handleBatchMigrate">同步临时订单</a-button>
        </div>
        <div class="tableBody">
          <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :row-key="record => record.id"
          >
            <template slot="action" slot-scope="text, record">
              <a-button-group size="small">
                <a-button v-if="$authority('merchantConfigView')" icon="eye" style="color: #1890ff;" type="link" @click="viewBtn(record)">查看</a-button>
                <a-button v-if="$authority('merchantConfigEdit')" icon="edit" style="color: #52c41a;" type="link" @click="editBtn(record)">编辑</a-button>
                <a-button v-if="$authority('merchantConfigApproval')" icon="audit" style="color: #faad14;" type="link" @click="openApprovalModal(record)">审核协议</a-button>
                <a-button v-if="$authority('merchantConfigStatView')" icon="bar-chart" style="color: #722ed1;" type="link" @click="statViewBtn(record)">统计</a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="pagination-wrapper">
        <LcfsPagination :fn="getTableData" :page-no.sync="pagination.pageNo" :page-size.sync="pagination.pageSize" :total="pagination.total"/>
      </div>
    </a-card>

    <!-- 查看详情弹窗 -->
    <a-modal
        v-model="viewModalVisible"
        :destroyOnClose="true"
        :footer="null"
        title="商户配置详情"
        width="65%"
    >
      <div class="detailBox">
        <a-descriptions :column="2" bordered size="small">
          <a-descriptions-item label="商户编号">{{ viewData.merchantNo || '-' }}</a-descriptions-item>
          <a-descriptions-item label="商户名称">{{ viewData.merchantName || '-' }}</a-descriptions-item>
          <a-descriptions-item label="个体户账户">
            <WalletInfo v-if="viewData.accountNo" :account-name="viewData.accountName" :account-no="viewData.accountNo" :show-account-name="true"/>
            <span v-else>-</span>
          </a-descriptions-item>
          <a-descriptions-item label="待清算账户">
            <WalletInfo v-if="viewData.settleAccountNo" :account-name="viewData.settleAccountName" :account-no="viewData.settleAccountNo"
                        :show-account-name="true"/>
            <span v-else>-</span>
          </a-descriptions-item>
          <a-descriptions-item label="服务费收款方">
            <WalletInfo v-if="viewData.feeAccountNo" :account-name="viewData.feeAccountName" :account-no="viewData.feeAccountNo" :show-account-name="true"/>
            <span v-else>-</span>
          </a-descriptions-item>
          <a-descriptions-item label="服务费规则">{{ viewData.feeRuleName || viewData.feeRuleNo || '-' }}</a-descriptions-item>
          <a-descriptions-item :span="2" label="服务费归集摘要">{{ viewData.serviceFeeRemark || '-' }}</a-descriptions-item>
        </a-descriptions>

        <a-divider>分润规则</a-divider>

        <a-table
            :columns="viewShareRuleColumns"
            :data-source="viewData.shareRules || []"
            :pagination="false"
            row-key="id"
            size="small"
        >
          <template slot="rate" slot-scope="text">
            {{ text ? (text * 100).toFixed(2) + '%' : '-' }}
          </template>
          <template slot="profitShareRemark" slot-scope="text">
            {{ text || '-' }}
          </template>
        </a-table>
      </div>

      <template #footer>
        <a-button @click="viewModalVisible = false">关闭</a-button>
      </template>
    </a-modal>

    <!-- 协议审核弹窗 -->
    <a-modal
        v-model="approvalModalVisible"
        :destroyOnClose="true"
        :footer="null"
        title="协议审核"
        width="65%"
    >
      <div v-if="approvalMerchant">
        <a-descriptions :column="2" bordered size="small" style="margin-bottom: 16px;">
          <a-descriptions-item label="商户编号">{{ approvalMerchant.merchantNo }}</a-descriptions-item>
          <a-descriptions-item label="商户名称">{{ approvalMerchant.merchantName }}</a-descriptions-item>
          <a-descriptions-item label="个体户账户">
            <WalletInfo :account-no="approvalMerchant.accountNo" :account-name="approvalMerchant.accountName" :show-account-name="true"/>
          </a-descriptions-item>
          <a-descriptions-item label="清分户">
            <WalletInfo :account-no="approvalMerchant.settleAccountNo" :account-name="approvalMerchant.settleAccountName" :show-account-name="true"/>
          </a-descriptions-item>
          <a-descriptions-item label="服务费收款方">
            <WalletInfo v-if="approvalMerchant.feeAccountNo" :account-no="approvalMerchant.feeAccountNo" :account-name="approvalMerchant.feeAccountName"
                        :show-account-name="true"/>
            <span v-else>-</span>
          </a-descriptions-item>
        </a-descriptions>

        <a-spin :spinning="approvalLoading" tip="加载中...">
          <a-table
              :columns="approvalColumns"
              :data-source="approvalList"
              :pagination="false"
              row-key="uid"
              size="small"
          >
            <template slot="contractType" slot-scope="text">
              <a-tag :color="text === '支付协议' ? 'blue' : 'purple'">{{ text }}</a-tag>
            </template>
            <template slot="checkStatus" slot-scope="text">
              <a-tag :color="{'0':'orange','1':'green','2':'red','3':'red','4':'default'}[(text || '')] || 'default'">
                {{ {'-1': '草稿', '0': '待审批', '1': '已通过', '2': '已拒绝', '3': '审批失败', '4': '已作废'}[(text || '')] || text }}
              </a-tag>
            </template>
            <template slot="action" slot-scope="text, record">
              <template v-if="record.contractType === 'PAY'">
                <a-popconfirm v-if="record.checkStatus !== '1'" title="确认同步到银行？" @confirm="syncPayContract(record)">
                  <a-button size="small" type="primary">通过</a-button>
                </a-popconfirm>
                <span v-else>-</span>
              </template>
              <template v-else>
                <template v-if="record.checkStatus === '0'">
                  <a-popconfirm title="确认审批通过？" @confirm="approveContract(record)">
                    <a-button size="small" type="primary">通过</a-button>
                  </a-popconfirm>
<!--                  <a-popconfirm title="确认拒绝？" @confirm="rejectContract(record)">-->
<!--                    <a-button size="small" type="danger" style="margin-left: 4px;">拒绝</a-button>-->
<!--                  </a-popconfirm>-->
                </template>
                <span v-else>-</span>
              </template>
            </template>
          </a-table>
        </a-spin>
      </div>

      <template #footer>
        <a-button @click="approvalModalVisible = false">关闭</a-button>
      </template>
    </a-modal>

    <!-- 统计视图弹窗 -->
    <account-stat-view
      ref="statView"
      :query-params="statQueryParams"
      :default-start-date="statDefaultStartDate"
    />
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import AccountStatView from "@/view/components/AccountStatView.vue";

export default {
  name: 'TaxMerchantConfig',
  components: {LcfsPagination, WalletInfo, AccountStatView},
  data() {
    return {
      pagination: {pageNo: 1, pageSize: 10, total: 0},
      tableData: [],
      columns: [
        {
          title: "No",
          customRender: (text, record, index) => `${(this.pagination.pageNo - 1) * this.pagination.pageSize + (index + 1)}`,
          align: "center",
          width: 50
        },
        {
          title: "商户编号",
          dataIndex: "merchantNo",
          align: "center",
          width: 120
        },
        {
          title: "商户名称",
          dataIndex: "merchantName",
          align: "center",
          width: 150
        },
        {
          title: "个体户",
          dataIndex: "accountNo",
          align: "center",
          width: 150,
          customRender: (text, row) => {
            return <WalletInfo accountNo={text} accountName={row.accountName} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "清算户",
          dataIndex: "settleAccountNo",
          align: "center",
          width: 150,
          customRender: (text, row) => {

            return <WalletInfo accountNo={text} accountName={row.settleAccountName} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "服务费收款账户",
          dataIndex: "feeAccountNo",
          align: "center",
          width: 150,
          customRender: (text, row) => {
            if (!text) return <div>-</div>;
            return <WalletInfo accountNo={text} accountName={row.feeAccountName} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          align: "center",
          width: 150,
          customRender: (text) => {
            if (!text) return "-";
            return this.formatDateTime(text);
          },
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          scopedSlots: {customRender: 'action'}
        }
      ],
      paramsData: {
        merchantNo: "",
        merchantName: "",
      },
      migrateLoading: false,

      // 审核弹窗
      approvalModalVisible: false,
      approvalMerchant: null,
      approvalList: [],
      approvalLoading: false,
      approvalColumns: [
        {title: '协议类型', dataIndex: 'contractTypeName', align: 'center', width: 90, scopedSlots: {customRender: 'contractType'}},
        {title: '付款方账号', dataIndex: 'accountNo', align: 'center', width: 150},
        {title: '付款方名称', dataIndex: 'accountName', align: 'center', width: 120},
        {title: '收款方账号', dataIndex: 'oppAccountNo', align: 'center', width: 150},
        {title: '收款方名称', dataIndex: 'oppAccountName', align: 'center', width: 120},
        {title: '审批状态', dataIndex: 'checkStatus', align: 'center', width: 80, scopedSlots: {customRender: 'checkStatus'}},
        {title: '操作', key: 'action', width: 120, scopedSlots: {customRender: 'action'}},
      ],

      // 查看弹窗
      viewModalVisible: false,
      viewData: {},

      viewShareRuleColumns: [
        {title: '渠道商账号', dataIndex: 'accountNo', align: 'center'},
        {title: '渠道商名称', dataIndex: 'accountName', align: 'center'},
        {title: '分润比例(%)', dataIndex: 'rate', align: 'center', scopedSlots: {customRender: 'rate'}},
        {title: '分润摘要', dataIndex: 'profitShareRemark', align: 'center', scopedSlots: {customRender: 'profitShareRemark'}},
      ],

      // 统计视图相关
      statQueryParams: {
        channel_no: '',
        app_no: '',
        account_no: '',
        account_name: '',
      },
    };
  },
  computed: {
    /** 默认查近三个月 */
    statDefaultStartDate() {
      const d = new Date();
      d.setMonth(d.getMonth() - 3);
      return d.toISOString().slice(0, 10);
    },
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        const date = new Date(dateTime);
        return date.toLocaleString('zh-CN');
      } catch (e) {
        return dateTime;
      }
    },

    async getTableData() {
      try {
        const res = await this.api.getMerchantConfigList({
          ...this.paramsData,
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
        });
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
        } else {
          message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        message.error("获取数据失败");
      }
    },

    handleQuery() {
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    handleReset() {
      this.paramsData = {
        merchantNo: "",
        merchantName: "",
      };
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    addBtn() {
      this.$router.push({path: '/tax/merchantConfigDetail', query: {mode: 'add'}});
    },

    async handleBatchMigrate() {
      this.migrateLoading = true;
      try {
        const res = await this.api.batchMigratePayOrder();
        if (res.code === 200) {
          this.$message.success(res.data || '批量迁移完成');
          this.getTableData();
        } else {
          this.$message.warning(res.info || '批量迁移失败');
        }
      } catch (e) {
        this.$message.error('批量迁移失败');
      } finally {
        this.migrateLoading = false;
      }
    },

    async viewBtn(record) {
      try {
        const res = await this.api.getMerchantConfigDetail(record.id);
        if (res.code === 200 && res.data) {
          this.viewData = {...res.data, shareRules: res.data.shareRules || []};
          this.viewModalVisible = true;
        } else {
          message.warning(res.info || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        message.error("获取详情失败");
      }
    },

    editBtn(record) {
      this.$router.push({path: '/tax/merchantConfigDetail', query: {id: record.id, mode: 'edit'}});
    },

    async openApprovalModal(record) {
      this.approvalMerchant = record;
      this.approvalModalVisible = true;
      await this.loadApprovalContracts(record);
    },

    async loadApprovalContracts(merchant) {
      this.approvalLoading = true;
      try {
        const payerAccounts = [merchant.accountNo];
        if (merchant.feeAccountNo) payerAccounts.push(merchant.feeAccountNo);

        const [detailRes, contractRes, payContractRes] = await Promise.all([
          this.api.getMerchantConfigDetail(merchant.id),
          this.api.payWithholdQueryByAccounts(payerAccounts),
          merchant.settleAccountNo ? this.api.payContractQueryByAccounts(merchant.settleAccountNo, merchant.accountNo) : Promise.resolve(null),
        ]);

        const mergedList = [];

        // 支付协议（清分户 → 个体户）
        if (payContractRes && payContractRes.code === 200 && payContractRes.data) {
          payContractRes.data.forEach(c => {
            mergedList.push({
              ...c,
              uid: 'pay_' + c.id,
              contractType: 'PAY',
              contractTypeName: '支付协议',
            });
          });
        }

        // 构造有效收款方集合
        const validPayees = new Set();
        if (merchant.feeAccountNo) {
          validPayees.add(merchant.feeAccountNo);
        }
        if (detailRes.code === 200 && detailRes.data && detailRes.data.shareRules) {
          detailRes.data.shareRules.forEach(r => {
            if (r.accountNo) validPayees.add(r.accountNo);
          });
        }

        // 代扣协议
        if (contractRes.code === 200 && contractRes.data) {
          contractRes.data
              .filter(c => validPayees.has(c.oppAccountNo))
              .sort((a, b) => {
                const aIsIndividual = a.accountNo === merchant.accountNo ? 0 : 1;
                const bIsIndividual = b.accountNo === merchant.accountNo ? 0 : 1;
                return aIsIndividual - bIsIndividual;
              })
              .forEach(c => {
                mergedList.push({
                  ...c,
                  uid: 'withhold_' + c.id,
                  contractType: 'WITHHOLD',
                  contractTypeName: '代扣协议',
                });
              });
        }

        this.approvalList = mergedList;
      } catch (e) {
        this.$message.error('加载协议列表失败');
        this.approvalList = [];
      } finally {
        this.approvalLoading = false;
      }
    },

    async syncPayContract(contract) {
      try {
        const res = await this.api.paySyncToBankApi({id: contract.id});
        if (res.code === 200) {
          this.$message.success('同步成功');
          await this.loadApprovalContracts(this.approvalMerchant);
        } else {
          this.$message.warning(res.info || '同步失败');
        }
      } catch (e) {
        this.$message.error('同步失败');
      }
    },

    async approveContract(contract) {
      try {
        const res = await this.api.payWithholdContractApproval({id: contract.id, checkStatus: '1'});
        if (res.code === 200) {
          this.$message.success('审批通过');
          await this.loadApprovalContracts(this.approvalMerchant);
        } else {
          this.$message.warning(res.info || '审批失败');
        }
      } catch (e) {
        this.$message.error('审批失败');
      }
    },

    async rejectContract(contract) {
      try {
        const res = await this.api.payWithholdContractApproval({id: contract.id, checkStatus: '2'});
        if (res.code === 200) {
          this.$message.success('已拒绝');
          await this.loadApprovalContracts(this.approvalMerchant);
        } else {
          this.$message.warning(res.info || '操作失败');
        }
      } catch (e) {
        this.$message.error('操作失败');
      }
    },

    /** 统计视图：打开弹窗查询该商户流水 */
    statViewBtn(record) {
      this.statQueryParams = {
        channel_no: record.channelNo || '',
        app_no: record.appNo || '',
        account_no: record.accountNo || '',
        account_name: record.accountName || '',
      };
      // 下次渲染后触发弹窗和数据加载
      this.$nextTick(() => {
        if (this.$refs.statView) {
          this.$refs.statView.show();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-right: 20px;

    span {
      margin-right: 8px;
      white-space: nowrap;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select {
      width: 200px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding: 12px 0;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-radius: 0 0 6px 6px;
}

.detailBox {
  padding: 10px;
}

.approval-section {
  /deep/ .ant-card-head {
    min-height: 36px;
    padding: 0 12px;

    .ant-card-head-title {
      font-size: 13px;
      font-weight: 600;
      padding: 6px 0;
    }
  }

  /deep/ .ant-card-body {
    padding: 8px;
  }
}
</style>